import React from 'react';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

// Static headers as per roles
const RoleHeader = React.memo(({ header, collapsed }) => {
  if (collapsed) {
    return <Divider sx={{ mx: 2, my: 2, borderColor: 'primary.light' }} />;
  }

  return (
    <Box
      display="flex"
      p={2}
      alignItems="center"
      flexDirection="row"
      gap="10px"
    >
      <Typography
        sx={{
          textTransform: 'uppercase',
          color: 'primary.dark',
          flexGrow: 1,
          fontSize: 14,
        }}
      >
        {header}
      </Typography>
      <Divider sx={{ borderColor: 'primary.light', flexGrow: 5 }} />
    </Box>
  );
});

RoleHeader.displayName = 'RoleHeader';

export default RoleHeader;
